import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/favorites/FavoritesClientWrapper.tsx");
